module.exports = __webpack_public_path__ + "img/icon-image.4a743249.svg";